const updates = [
  {
    date: '2026-07-31',
    title: '《迷雾追踪》全集上线',
    desc: '豆瓣8.7分高分悬疑剧全12集一次性放出，追剧党可以一口气看完。',
    tag: '新片上线',
  },
  {
    date: '2026-07-30',
    title: '暑期档科幻专题页面上线',
    desc: '整理18部热门科幻新片，包含《星际迷航：新纪元》等重磅大片。',
    tag: '专题更新',
  },
  {
    date: '2026-07-29',
    title: '播放器升级至V3.2版本',
    desc: '优化视频加载速度，新增智能画质切换功能，观看体验更流畅。',
    tag: '功能升级',
  },
  {
    date: '2026-07-28',
    title: '《欢乐喜剧人》新季首播',
    desc: '现象级喜剧综艺回归，首期节目已上线麻花影院免费观看。',
    tag: '综艺上新',
  },
  {
    date: '2026-07-27',
    title: '经典港片4K修复专区开放',
    desc: '50余部经典香港电影完成4K修复，画质焕然一新，免费观看。',
    tag: '专区上线',
  },
  {
    date: '2026-07-26',
    title: '手机端适配优化完成',
    desc: '全面提升移动端播放稳定性，修复已知bug，观影更顺畅。',
    tag: '体验优化',
  },
  {
    date: '2026-07-25',
    title: '新增「观影日历」功能模块',
    desc: '追剧日程一目了然，再也不怕错过更新。PC和手机端同步上线。',
    tag: '新功能',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            最新更新
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            实时了解麻花影院最新片源上线与功能动态
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200 space-y-8">
            {updates.map((item, idx) => (
              <div key={idx} className="relative" style={{ animationDelay: `${idx * 80}ms` }}>
                <div className="absolute -left-[25px] md:-left-[29px] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-400 whitespace-nowrap pt-0.5">{item.date}</span>
                  <div>
                    <div className="flex items-center gap-2 mb-1 flex-wrap">
                      <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                        {item.title}
                      </h3>
                      <span className="text-[10px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}